import { Marker, MarkerClusterer } from '@react-google-maps/api';
import {
  Clusterer,
  ClustererOptions
} from '@react-google-maps/marker-clusterer';
import { imageUrl } from '@/vm/Shared/imageUrl';
import type { VendingMachineLocation } from '~/contracts/vm';

// use random 50% left and right placement to improve label placement
const getMapLabelLocation = (text: string) => {
  const isShort = text.length <= 15;
  const offsetY = 20;

  const offsetX = isShort ? 85 + text.length : 85 + text.length * 1.75;

  return new google.maps.Point(offsetX, offsetY);
};

const emptyLabel = ' '; // must be space and not empty
const carvanaMapMarker = imageUrl('carvana_map_marker.png');
const carvanaClusterMarker = imageUrl('carvana_cluster_marker');

const clustererOptions: ClustererOptions = {
  imagePath: carvanaClusterMarker,

  imageExtension: 'png',
  styles: [
    {
      textColor: '#ffffff',
      textSize: 18,
      anchorText: [-10, -9],
      width: 52,
      height: 52,
      url: `${carvanaClusterMarker}.png`
    }
  ]
};

type MarkersProps = {
  activeLocation: { label: string };
  clusterer: Clusterer;
  onMarkerClick: (label: string, e: google.maps.MapMouseEvent) => void;
  showMarkerLabels: boolean;
  vendingMachineLocations: VendingMachineLocation[];
};

function Markers({
  activeLocation,
  clusterer,
  onMarkerClick,
  showMarkerLabels,
  vendingMachineLocations
}: MarkersProps) {
  return vendingMachineLocations.map((location, i) => {
    const labelText = showMarkerLabels ? location.label : emptyLabel;

    return (
      <Marker
        onClick={(e: google.maps.MapMouseEvent) =>
          onMarkerClick(location.label, e)
        }
        key={i}
        clusterer={clusterer}
        animation={
          activeLocation.label === location.label
            ? google.maps.Animation.DROP
            : undefined
        }
        position={location}
        label={{
          text: labelText || '',
          fontSize: '18px'
        }}
        title={location.label || ''}
        icon={{
          url: carvanaMapMarker,
          labelOrigin: getMapLabelLocation(location.label)
        }}
      />
    );
  });
}

export type OwnProps = {
  activeLocation: {
    label: string;
  };
  center: {
    lat: number;
    lng: number;
  };
  enableClustering: boolean;
  isVisible: boolean;
  onMapLoad: (mapResult: google.maps.Map) => void;
  onMarkerClick: (label: string, e: google.maps.MapMouseEvent) => void;
  onZoomChanged: () => void;
  showMarkerLabels: boolean;
  vendingMachineLocations: VendingMachineLocation[];
  zoom: number;
  zoomStyles: google.maps.MapTypeStyle[];
};

export default function LocationMarkers(props) {
  const { enableClustering } = props;

  return enableClustering ? (
    <MarkerClusterer options={clustererOptions}>
      {clusterer => <Markers {...props} clusterer={clusterer} />}
    </MarkerClusterer>
  ) : (
    <Markers {...props} clusterer={undefined} />
  );
}
